<template>
  <div class="modal fade" id="branchUserCreateUpdateModel" tabindex="-1" aria-labelledby="branchUserCreateUpdateModelLabel" aria-hidden="true" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!loaded">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="branchUserCreateUpdateModelLabel">
            <span v-if="modalData.title" class="text-gray-600" v-html="modalData.title"></span>
            <span v-else class="text-gray-600">Новый сотрудник</span>
          </h5>
          <button @click="clearForm" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div v-if="error" class="alert alert-danger d-flex align-items-center px-5 py-3">
            <span v-html="error"></span>
          </div>
          <form @submit.prevent="addUser">
            <input-field
                v-model="this.form.c_id"
                id="form.c_id"
                name="form.c_id"
                :mb="5"
                placeholder="1C ID"
                type="text"
                :disabled="!roleAdmin.includes(this.$user.role)"
            />
            <input-field
                v-model="this.form.id_physperson"
                id="form.id_physperson"
                name="form.id_physperson"
                :mb="5"
                placeholder="1C ID Физ. лица"
                type="text"
                :disabled="!roleAdmin.includes(this.$user.role)"
            />
            <div class="row">
              <div class="col-6">
                <input-mask-field
                    v-model="form.iin"
                    :disabled="modalData.isEdit || !(roleAdmin.includes(this.$user.role) || roleModerator.includes(this.$user.role))"
                    id="form.iin"
                    name="form.iin"
                    :required="true"
                    :mb="5"
                    mask="### ### ### ###"
                    placeholder="ИИН"
                    type="text"
                />
              </div>
              <div class="col-6">
                <input-mask-field
                    v-model="form.phone"
                    id="form.phone"
                    name="form.phone"
                    :required="true"
                    :mb="5"
                    placeholder="Номер телефона"
                    mask="+7(###) ###-####"
                    type="text"
                    :disabled="!roleModerator.includes(this.$user.role)"
                />
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-6">
                  <input-field
                      v-model="this.form.name"
                      id="form.name"
                      name="form.name"
                      :required="true"
                      :mb="5"
                      placeholder="Имя"
                      type="text"
                      :disabled="!roleAdmin.includes(this.$user.role)"
                  />
                </div>
                <div class="col-6">
                  <input-field
                      v-model="this.form.surname"
                      id="form.surname"
                      name="form.surname"
                      :required="true"
                      :mb="5"
                      placeholder="Фамилия"
                      type="text"
                      :disabled="!roleAdmin.includes(this.$user.role)"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <input-field
                      v-model="this.form.patronymic"
                      id="form.patronymic"
                      name="form.patronymic"
                      :required="false"
                      :mb="5"
                      placeholder="Отчество"
                      type="text"
                      :disabled="!roleAdmin.includes(this.$user.role)"
                  />
                </div>
                <div class="col-6">
                  <input-field
                      v-model="this.form.email"
                      id="form.email"
                      name="form.email"
                      :required="false"
                      :mb="5"
                      placeholder="Эл.почта"
                      type="email"
                      :disabled="!roleModerator.includes(this.$user.role)"
                  />
                </div>
              </div>
              <checkbox-field
                  v-model="isDep"
                  @click="roleAdmin.includes(this.$user.role) ? setNullParent() : null"
                  placeholder="Привязано к Департамент"
                  id="form.isDep"
                  class="form-check-sm mb-3 h-35px rounded ps-2"
                  :disabled="!roleModerator.includes(this.$user.role)"
              />
              <div class="custom-select dynamic" v-if="getDUsers && getDDepartments">
                <label for="form.parent_id">Привязано к</label>
                <v-select
                    v-model="form.parent_id"
                    input-id="form.parent_id"
                    :options="isDep ? getDDepartments : getDUsers"
                    :reduce="item => item.id"
                    :required="true"
                    :placeholder="isDep ? 'Выберите департамент' : 'Выберите сотрудника'"
                    class="mb-3 bg-gray-100 form rounded"
                    label="name"
                    :disabled="!roleModerator.includes(this.$user.role)"
                />
              </div>
              <div class="row">
                <div class="col-4">
                  <select-field-from-model
                      v-model="this.form.role"
                      v-if="this.modalData.role === 0 || this.modalData.role === 1"
                      id="form.role"
                      name="form.role"
                      :options="this.$user.role === 1 ? this.moderatorRoles : this.allRoles "
                      placeholder="Роль"
                      mb="5"
                  />
                </div>
                <div class="col-8">
                  <div class="custom-select dynamic" v-if="getDTerminals">
                    <label for="form.terminal_id">Терминал</label>
                    <v-select
                        v-model="form.terminal_id"
                        input-id="form.terminal_id"
                        :options="getDTerminals"
                        :reduce="item => item.id"
                        :required="true"
                        placeholder="Выберите..."
                        class="mb-3 bg-gray-100 form rounded"
                        label="name"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <input-field
                      v-model="this.form.birthday"
                      id="form.birthday"
                      name="form.birthday"
                      :required="false"
                      placeholder="День рождения"
                      type="date"
                      :disabled="!roleAdmin.includes(this.$user.role)"
                  />
                </div>
                <div class="col-4">
                  <select-field-from-model
                      v-model="this.form.sex"
                      id="form.sex"
                      name="form.sex"
                      :options="[{id: 1, name: 'Мужской'},{id: 2, name: 'Женский'}]"
                      :required="true"
                      placeholder="Пол"
                      :disabled="!roleAdmin.includes(this.$user.role)"
                  />
                </div>
                <div class="col-4">
                  <select-field-from-model
                      v-model="this.form.status"
                      id="form.status"
                      name="form.status"
                      :options="[{id: 1, name: 'Активный'},{id: 2, name: 'Неактивный'}]"
                      :required="true"
                      placeholder="Статус"
                      :disabled="!roleModerator.includes(this.$user.role)"
                  />
                </div>
              </div>
              <div class="mt-5 text-center">
                <button
                    :disabled="this.error"
                    type="submit"
                    class="btn btn-sm btn-primary"
                >Сохранить</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="min-height: 319px"/>
      </div>
    </div>
  </div>
</template>

<script>
import SelectFieldFromModel from '@/components/Fields/SelectFieldFromModel'
import InputMaskField       from '@/components/Fields/InputMaskField'
import CheckboxField        from '@/components/Fields/CheckboxField'
import InputField           from '@/components/Fields/InputField'
import LoaderFull           from '@/components/Main/LoaderFull'
// Other
import permissions          from '@/helpers/permissions'
import vSelect              from 'vue-select'
import axios                from 'axios'

export default {
  name: 'BranchUserCreateUpdateModel',
  components: { SelectFieldFromModel, InputMaskField, CheckboxField, LoaderFull, InputField, vSelect },
  props: {
    page: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loaded: false,
      error:  null,
      isDep:  false,
      form: {
        phone:       '+7',
        iin:         '',
        economics_sector_id: null,
        activity_kind_id: null,
        id_physperson: null,
        terminal_id: null,
        patronymic:  null,
        parent_id:   null,
        birthday:    null,
        surname:     null,
        is_head:     0,
        address:     null,
        person:      1,
        status:      1,
        email:       null,
        name:        null,
        role:        null,
        sex:         1,
      }
    }
  },
  computed: {
    getDDepartments() { return this.$store.getters.getDepartmentsDic },
    getDTerminals()   { return this.$store.getters.getTerminalsDic },
    getDUsers()       { return this.$store.getters.getUsersDic },
    modalData()       { return this.$store.getters.getBranchUserCreateUpdateModel },
    allRoles()        { return permissions.allRolesToCreate()},
    moderatorRoles()  { return permissions.rolesFromModerator()},
    roleModerator()   { return permissions.moderator() },
    roleAdmin()       { return permissions.admin() },
    roleModerator()   { return permissions.moderator() }
  },
  methods: {
    addUser() {
      this.loaded = true
      const data = {form:this.form, isEdit: this.modalData.isEdit, id:this.modalData.id, isDep: this.isDep}
      axios.post('/api/branches/create-user', data)
          .then(res => {
            if (res.data.result) {
              this.$emit('reloaded', this.page)
              this.modalHidden()
            } else {
              this.error = res.data.message
            }
          })
          .catch(err => {
            if (err.response) {
              this.error = err.response.data.message
            } else {
              this.error = err.message
            }
          })
          .finally(() => this.loaded = false)
    },
    clearForm() {
      this.form = {
        phone:       '+7',
        iin:         '',
        economics_sector_id: null,
        activity_kind_id: null,
        id_physperson: null,
        terminal_id: null,
        patronymic:  null,
        parent_id:   null,
        birthday:    null,
        surname:     null,
        is_head:     0,
        address:     null,
        person:      1,
        status:      1,
        email:       null,
        name:        null,
        role:        null,
        sex:         1,
      }
      this.searchLoaded  = false
      this.loaded        = false
      this.error         = null
    },
    getItem(id, isEdit) {
      this.loaded = true
      axios.post('/api/branches/user-item', {id:id, isEdit: isEdit})
          .then(res => {
            if (res.data.result) {
              if (isEdit) {
                this.form = res.data.data
                this.isDep = res.data.isDep
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {this.loaded = false})
    },
    modalHidden() {
      const myModalEl = document.getElementById('branchUserCreateUpdateModel');
      const modal = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
      this.clearForm()
    },
    setNullParent() {
      this.form.parent_id = null
    }
  },
  watch: {
    'form.phone': {
      deep: true,
      handler(newValue) {
        if (newValue.length <= 1) this.form.phone = '+7'
      }
    },
    'form.iin': {
      deep: true,
      handler(newValue) {
        if (newValue.length > 0) this.error = null
        if (newValue.length === 15 && !this.modalData.isEdit) {
          this.loaded = true
          axios.post('/api/branches/employee', {iin:newValue})
              .then(res => {
                if (res.data.hasOwnProperty('result')) {
                  if (res.data.result === 1) {
                    const data = res.data.data
                    this.form.economics_sector_id = data.economics_sector_id
                    this.form.activity_kind_id    = data.activity_kind_id
                    this.form.id_physperson       = data.id_physperson
                    this.form.patronymic          = data.patronymic
                    this.form.birthday            = data.birthday
                    this.form.surname             = data.surname
                    this.form.address             = data.address
                    this.form.person              = data.person
                    this.form.email               = data.email
                    this.form.name                = data.name
                    this.form.sex                 = data.sex
                    if (data.c_id) this.form.c_id = data.c_id
                  }
                  if (res.data.result === 0 || !res.data.result) {
                    this.$notifyError(res.data)
                    this.error = res.data.message
                  }
                }
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => {this.loaded = false})
        }
      }
    },
    modalData: {
      deep: true,
      handler(newValue) {
        this.clearForm()
        this.form.role = newValue.role
        this.getItem(newValue.id, newValue.isEdit)
        if (this.$user.role === 1) this.form.role = 8
      }
    }
  }
}
</script>

<style scoped>

</style>